<nz-modal [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="'100%'" nzCentered
  [nzVisible]="isVisibleIdleModal" [nzTitle]="''" [nzFooter]="switchAccountFooter" nzClassName="switc-ac-modal all-done-modal"
  [nzClosable]="false">
  <ng-container *nzModalContent class="h-100">
    <div >
      <h1 class="page-title-text sites-text center fs-35">All done?</h1>
      <div class="d-flex flex-wrap justify-content-center" style="margin-bottom:auto ;">
          <div class="pr-2 website-logo">
            <p>We'll log you out in a few minutes</p>
            <button nz-button (click)="stayLoggedIn()" style="margin: 35px auto;">Stay Logged In</button>
          </div>
      </div>
    </div>
  </ng-container>
  <ng-template #switchAccountFooter>
  </ng-template>
</nz-modal>
<router-outlet></router-outlet>